import { useContext } from 'react';
import { DeviceContext } from '@/providers/DeviceProvider/DeviceProvider';

/**
 * Custom hook to access the user's device info
 * @returns The device context value.
 */
export function useDevice() {
  const context = useContext(DeviceContext);

  if (!context) {
    throw new Error('useDevice must be used within an DeviceProvider');
  }
  return context;
}
